import styled from "styled-components"
import { formatDate } from 'utils/utils';

export default function OrderUniqueInfo({ orderNo, orderDate }) {
  return (
    <Block>
      <UniqueInfo>주문 번호: {orderNo} | 주문일자 : {formatDate(orderDate, '.')}</UniqueInfo>
    </Block>
  )
}

const Block = styled.div`
  margin-bottom: calc(100vw * (17 / 375));
`;

const UniqueInfo = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (14.4 / 375));
  color: #7F7F7F;
`;